import { Form } from 'antd'
import { useForm } from 'antd/es/form/Form'
import { FormInstance } from 'antd/lib'
import * as React from 'react'
import { FC } from 'react'

export const EditableContext = React.createContext<FormInstance<any> | null>(null)

interface EditableRowProps {
    index: number
}

const EditableRow: FC<EditableRowProps> = ({ index, ...props }) => {
    const [form] = useForm()
    return (
        <Form form={form} component={false}>
            <EditableContext.Provider value={form}>
                <tr {...props} />
            </EditableContext.Provider>
        </Form>
    )
}

export default EditableRow
